// extracted by mini-css-extract-plugin
export default {"disabledLabel":"RTEConfig-disabledLabel-74ed855fc140506c466007da4020785a","spoilerDesc":"RTEConfig-spoilerDesc-f83a8d202f2f890307ee24e1a5ff7ff2"};